import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Button, Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment, Stack } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
// component
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  minHeight: 96,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

EndorsementListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  onExactSearch: PropTypes.func,
  onClearSearch: PropTypes.func,
  hasExactSearch: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
};

export default function EndorsementListToolbar({
  numSelected,
  filterName,
  onFilterName,
  onExactSearch,
  onClearSearch,
  hasExactSearch,
  searchPlaceholder = 'Código ou UUID',
}) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onExactSearch?.();
    }
  };

  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
          <StyledSearch
            value={filterName || ''}
            onChange={onFilterName}
            onKeyDown={handleKeyDown}
            placeholder={searchPlaceholder}
            startAdornment={
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
              </InputAdornment>
            }
          />
          {onExactSearch && (
            <Button
              variant="contained"
              size="small"
              onClick={onExactSearch}
              startIcon={<Iconify icon="eva:search-fill" />}
            >
              Buscar
            </Button>
          )}
          {onClearSearch && (filterName || hasExactSearch) && (
            <Button variant="outlined" size="small" onClick={onClearSearch}>
              Limpar
            </Button>
          )}
        </Stack>
      )}

      {numSelected > 0 ? (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Tooltip title="Delete">
            <IconButton>
              <Iconify icon="eva:trash-2-fill" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download">
            <IconButton>
              <ArrowDownwardIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      ) : null}
    </StyledRoot>
  );
}
